var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplementoPago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.14 14.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#93bacc;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.07,
    cy: 7.07,
    r: 7.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7,8.67A11.4,11.4,0,0,1,6.53,10a8.57,8.57,0,0,1-1.64.21,3,3,0,0,1-3.25-3A3.12,3.12,0,0,1,5.05,4.13a8.77,8.77,0,0,1,1.7.21c0,.4.1.94.17,1.39l-.28.06a1.55,1.55,0,0,0-.85-1.16,2.69,2.69,0,0,0-1-.17c-1.48,0-2.27,1.1-2.27,2.59,0,1.73.9,2.85,2.36,2.85.92,0,1.37-.42,1.83-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.21,4.26a2.57,2.57,0,0,1,1.53.38,1.53,1.53,0,0,1,.59,1.28,1.86,1.86,0,0,1-2,1.85l-.24,0-.62-.16V9c0,.76.06.78.89.87v.25H7.89V9.86c.78-.09.81-.14.81-.89V5.4c0-.8-.1-.82-.81-.89V4.26Zm-.72,3a1.48,1.48,0,0,0,.65.12A1.28,1.28,0,0,0,11.49,6a1.28,1.28,0,0,0-1.4-1.39.8.8,0,0,0-.5.11c-.08.06-.1.17-.1.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplementoPago);
export default __webpack_public_path__ + "static/media/complemento_pago.ec1feb59208beebf1aab26cc1ef19e2c.svg";
export { ForwardRef as ReactComponent };